export const updateUrlWithLocale = (url, locale) => {
    if (typeof url === 'string') {
        return url.replace('{{locale}}', locale);
    }
    return url;
}

export const cacheImages = async (srcArray, rootFolder, locale) => {
    const promises = await srcArray.map((src) => {
        return new Promise(function (resolve, reject) {
            const img = new Image();
            img.src = rootFolder + updateUrlWithLocale(src, locale);
            img.onload = () => resolve();
            img.onerror = () => reject();
        });
    });
    return Promise.all(promises);
}
